import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "ManageDep";

export const getDepList = createAsyncThunk(
  `${namespace}/getDepList`,
  async (body, { rejectWithValue }) => {
    const api = "departmentLists";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createDepartment = createAsyncThunk(
  `${namespace}/createDepartment`,
  async (body, { rejectWithValue }) => {
    const api = "departmentcreate";
    const opt = {
      method: "POST",
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateDepartment = createAsyncThunk(
  `${namespace}/updateDepartment`,
  async (body, { rejectWithValue }) => {
    const api = "departmentupdate";
    const replace = {
      search: "id",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getDepByID = createAsyncThunk(
  `${namespace}/getDepById`,
  async (body, { rejectWithValue }) => {
    console.log(body);
    const api = "getdepartmentbyid";
    const replace = {
      search: "id",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getDepZkByID = createAsyncThunk(
  `${namespace}/getDepZkById`,
  async (body, { rejectWithValue }) => {
    console.log(body);
    const api = "getdepartmentZktecobyid";
    const replace = {
      search: "id",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);


const initialState = {
  department: {
    zkteco_department_id: "",
    description: "",
    status: {
      id: 1
    }    
  },
  departmentLists: [],
};

const manageDepSlice = createSlice({
  name: "manageDep",
  initialState,
  reducers: {
    updateDepartment2(state, action) {
      return { ...state, department: action.payload };
    },
    resetDepartment(state, action) {
      return { ...state, department:initialState.department };
    },
  },
  extraReducers: {
    [getDepList.pending]: (state, action) => {
      state.loading = true;
    },
    [getDepList.fulfilled]: (state, action) => {
      state.loading = false;
      state.departmentLists = [];
      state.departmentLists = [...state.departmentLists, ...action.payload];
      console.log(action.payload);
    },
    [getDepList.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },

    [createDepartment.pending]: (state, action) => {
      state.loading = true;
    },
    [createDepartment.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [createDepartment.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },

    [updateDepartment.pending]: (state, action) => {
      state.loading = true;
    },
    [updateDepartment.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [updateDepartment.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [getDepByID.pending]: (state, action) => {
      state.loading = true;
    },
    [getDepByID.fulfilled]: (state, action) => {
      state.loading = false;
      state.department=action.payload;
      console.log(action.payload);
    },
    [getDepByID.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [getDepZkByID.pending]: (state, action) => {
      state.loading = true;
    },
    [getDepZkByID.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [getDepZkByID.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },
});

export const { updateDepartment2, resetDepartment } = manageDepSlice.actions;
export default manageDepSlice.reducer;
